import { render, staticRenderFns } from "./TableComp.vue?vue&type=template&id=30a32d8e&"
import script from "./TableComp.vue?vue&type=script&lang=ts&"
export * from "./TableComp.vue?vue&type=script&lang=ts&"
import style0 from "./TableComp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports